module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-rich88.d6218f7f.png";